import React from 'react';
import { Line, WrapperBox } from './PasswordStrengthChecker.style-elements';
import {
  getActiveColor,
  isMediumPasswordRe,
  isStrongPasswordRe,
  isWeekPasswordRe,
} from './PasswordStrengthChecker.utils';

interface PasswordStrengthCheckerProps {
  password?: string;
}

const PasswordStrengthChecker: React.FC<PasswordStrengthCheckerProps> = ({
  password = '',
}) => {
  const isStrongPassword = !!password.match(isStrongPasswordRe);
  const isMediumPassword = !!password.match(isMediumPasswordRe);
  const isWeekPassword = !!password.match(isWeekPasswordRe);
  const activeColor = getActiveColor({
    isStrongPassword,
    isMediumPassword,
    isWeekPassword,
  });
  const lines = [
    { id: 0, bgcolor: activeColor, active: true },
    { id: 1, bgcolor: activeColor, active: isMediumPassword },
    { id: 2, bgcolor: activeColor, active: isStrongPassword },
  ];

  return (
    <WrapperBox>
      {lines.map(({ id, ...otherProps }) => (
        <Line key={id} {...otherProps} />
      ))}
    </WrapperBox>
  );
};

export default PasswordStrengthChecker;
